import { combineReducers } from "redux";
import user from "./user";
import config from "./config";

export default combineReducers({
  config,
  user,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js